import { Checkbox, Field, Input, Select } from '@itds/elements/index.js';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const BaseProduct = ({ loadDataVersion, version }) => {
  const [data, setData] = useState({
    max_annuitant_issue_age: version.max_annuitant_issue_age,
    max_owner_issue_age: version.max_owner_issue_age,
    min_annuitant_issue_age: version.min_annuitant_issue_Age,
    min_owner_issue_age: version.min_owner_issue_age,
    qualified: version.qualified,
    non_qualified: version.non_qualified,
    surrender_charge_period: version.surrender_charge_period,
    surrender_charge_schedule: version.surrender_charge_schedule
  });

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  return (
    <>
      <Field label='Maximum Annuitant Issue Age'>
        <Input
          onChange={handleInputChange.bind(null, 'max_annuitant_issue_age')}
          value={data.max_annuitant_issue_age}
        />
      </Field>

      <Field label='Minimum Annuitant Issue Age'>
        <Input
          onChange={handleInputChange.bind(null, 'min_annuitant_issue_age')}
          value={data.min_annuitant_issue_age}
        />
      </Field>

      <Field label='Maximum Owner Issue Age'>
        <Input
          onChange={handleInputChange.bind(null, 'max_owner_issue_age')}
          value={data.max_owner_issue_age}
        />
      </Field>

      <Field label='Minimum Owner Issue Age'>
        <Input
          onChange={handleInputChange.bind(null, 'min_owner_issue_age')}
          value={data.min_owner_issue_age}
        />
      </Field>

      <Field label='Qualified'>
        <Checkbox
          onChange={handleInputChange.bind(null, 'qualified')}
          value={data.qualified}
        ></Checkbox>
      </Field>

      <Field label='Non Qualified'>
        <Checkbox
          onChange={handleInputChange.bind(null, 'non_qualified')}
          value={data.non_qualified}
        ></Checkbox>
      </Field>

      <Field label='Surrender Charge Period'>
        <Select
          onChange={handleInputChange.bind(null, 'surrender_charge_period')}
          options={[
            { value: '1' },
            { value: '2' },
            { value: '3' },
            { value: '4' },
            { value: '5' },
            { value: '6' },
            { value: '7' },
            { value: '8' },
            { value: '9' },
            { value: '10' }
          ]}
          value={data.surrender_charge_period}
        />
      </Field>
      <Field label='Surrender Charge Schedule'>
        <Select
          onChange={handleInputChange.bind(null, 'surrender_charge_schedule')}
          options={[
            { value: '1' },
            { value: '2' },
            { value: '3' },
            { value: '4' },
            { value: '5' },
            { value: '6' },
            { value: '7' },
            { value: '8' },
            { value: '9' },
            { value: '10' },
            { value: '11' },
            { value: '12' },
            { value: '13' },
            { value: '14' },
            { value: '15' }
          ]}
          value={data.surrender_charge_period}
        />
      </Field>
    </>
  );
};

BaseProduct.propTypes = { loadDataVersion: PropTypes.func, version: PropTypes.object };

export default BaseProduct;
